import { createContext, useContext } from "react";

import type { ResolvedPlacement } from "@/client/features/docs/docs-api";

/**
 * Shared state for resolved doc placements. Kept separate from the render
 * components so the components file exports only components (fast-refresh
 * friendly).
 */
export const PlacementsContext = createContext<ResolvedPlacement[]>([]);

/** All placements for a slot, in render order. */
export function usePlacements(slot: string): ResolvedPlacement[] {
  const all = useContext(PlacementsContext);
  return all.filter((p) => p.slot === slot);
}
